module.exports = __webpack_public_path__ + "static/img/average_bg.bbbac4d6.png";